import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import { BsFillSunFill, BsMoonFill } from "react-icons/bs";
import logoDark from "../assets/logoDark.png";
import logoLight from "../assets/logoLight.png";
import { CiShoppingCart } from "react-icons/ci";
import { CartContext } from "../CartContext";
import CartProduct from "./CartProduct";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";

const Navbar = ({ switchTheme, theme }) => {
  const cart = useContext(CartContext);
  const [modal, setModal] = useState(false);
  const [toggle, setToggle] = useState(false);
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();

  useEffect(() => {
    if (pathname === "/") {
      setActiveTab("home");
    } else if (pathname === "/prints") {
      setActiveTab("prints");
    } else if (pathname === "/contact") {
      setActiveTab("contact");
    } else if (pathname === "/about-us") {
      setActiveTab("about-us");
    }
  }, [pathname]);

  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0
  );

  return (
    <Container>
      <Link to={"/"} className="link-styles">
        {theme === "dark" ? (
          <img src={logoDark} alt="" />
        ) : (
          <img src={logoLight} alt="" />
        )}
      </Link>
      <ul className={toggle ? "nav-menu active" : "nav-menu"}>
        <Link to={"/"} className="link-styles" onClick={handleToggle}>
          <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
            Home
          </li>
        </Link>
        <Link to={"/prints"} className="link-styles" onClick={handleToggle}>
          <li className={activeTab === "prints" ? "activeTab" : "nonActive"}>
            Prints
          </li>
        </Link>
        <Link to={"/contact"} className="link-styles" onClick={handleToggle}>
          <li className={activeTab === "contact" ? "activeTab" : "nonActive"}>
            {t("contact")}
          </li>
        </Link>
        <Link to={"/about-us"} className="link-styles" onClick={handleToggle}>
          <li className={activeTab === "about-us" ? "activeTab" : "nonActive"}>
            {t("aboutUs")}
          </li>
        </Link>
        <div className="mobileIcons">
          <LanguageSelector />
          <div className="cartIcon">
            <CiShoppingCart onClick={() => setModal(!modal)} className="icon" />
            <h4>{productsCount}</h4>
          </div>
        </div>
        <LanguageSelector />
        <div className="cartIcon">
          <CiShoppingCart onClick={() => setModal(!modal)} className="icon" />
          <h4>{productsCount}</h4>
        </div>
        <div className="toggleTheme" onClick={switchTheme}>
          {theme === "light" ? (
            <BsMoonFill className="themeIcon" />
          ) : (
            <BsFillSunFill className="themeIcon" />
          )}
        </div>
      </ul>
      <div className={modal ? "modal" : "closedModal"}>
        <span>
          <div>
            <CiShoppingCart className="icon" />
            <h3>
              {t("cartItems")} ({productsCount})
            </h3>
          </div>
          <button className="x" onClick={() => setModal(false)}>
            X
          </button>
        </span>
        {productsCount === 0 ? (
          <span className="emptyCart">
            <h2>{t("emptyCart")}</h2>
            <p>
              Visit{" "}
              <Link to={"/prints"} className="link">
                Prints
              </Link>{" "}
              to add art to cart.
            </p>
          </span>
        ) : (
          <>
            <div className="items">
              <div className="item">
                {cart.items.map((currentProduct, idx) => (
                  <CartProduct
                    key={idx}
                    id={currentProduct.id}
                    quantity={currentProduct.quantity}
                    canvasType={currentProduct.canvasType} // Pass canvasType
                    selectedSize={currentProduct.selectedSize} // Pass selectedSize
                    price={currentProduct.price} // Pass price
                  />
                ))}
              </div>
            </div>
            <h2 className="totalPrice">
              {t("totalPrice")}: {cart.getTotalCost().toFixed(2)}€
            </h2>
            <Link to={"/checkout"} className="link-styles">
              <button onClick={() => setModal(false)}>{t("checkout")}</button>
            </Link>
          </>
        )}
      </div>
      <div className="mobile-menu" onClick={handleToggle}>
        {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
      </div>
    </Container>
  );
};
const Container = styled.div`
  background: var(--trPrimaryBackgroundColor);
  transition: 0.4s;
  backdrop-filter: blur(7px);
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 4%;
  width: 100%;
  height: 70px;
  z-index: 100;
  box-sizing: border-box;
  img {
    margin-top: 7px;
    width: 90px;
  }
  .closedModal {
    display: none;
    transition: 0.4s;
  }
  .mobileIcons {
    display: none;
  }
  .modal {
    transition: 0.4s;
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    height: 100vh;
    overflow-y: scroll;
    width: 400px;
    max-width: 440px;
    background: #070707;
    padding: 2em 14px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 2px var(--shadowColor);
    .emptyCart {
      flex-direction: column;
      margin-top: 30%;
      h2 {
        font-weight: 400;
      }
      p {
        color: gray;
        font-weight: 300;
      }
      .link {
        color: white;
      }
    }
    span {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
        gap: 1em;
        .icon {
          color: white;
          cursor: pointer;
        }
        h3 {
          font-weight: 300;
        }
      }
      .x {
        color: white;
        background: none;
        border: none;
        font-size: 1.4em;
        position: absolute;
        right: 1em;
      }
    }
    .items {
      margin-top: 2em;
      .item {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        /* align-items: center; */
        gap: 1em;
        flex-direction: column;
        img {
          width: 150px;
        }
        span {
          .quantity {
            h3 {
              text-align: start;
              justify-self: start;
            }
          }
        }
        /* span {
          display: flex;
          flex-direction: column;
          gap: 8px;
          h2 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3 {
              font-size: 17px;
              font-weight: 400;
              width: 100%;
            }
            .icon {
              font-size: 1em;
              color: white;
            }
          }
          h4 {
            font-size: 17px;
            font-weight: 300;
            color: gray;
          }
          .quantity {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              gap: 10px;
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 30px;
                width: 30px;
                height: 30px;
                border: none;
                background: white;
                color: black;
                border-radius: 8px;
              }
              h1 {
                font-weight: 300;
              }
            }
          }
        } */
      }
    }
    button {
      margin: auto;
      display: flex;
      margin-top: 1em;
      font-family: "Montserrat", sans-serif;
      font-size: 17px;
      padding: 12px 17px;
      border: none;
      background: white;
      border-radius: 20px;
      cursor: pointer;
    }
    .totalPrice {
      margin-top: 2em;
      font-weight: 400;
      text-align: center;
    }
  }
  .nav-menu {
    display: flex;
    gap: 37px;
    list-style: none;
    align-items: center;
    li {
      color: var(--fontSecondaryColor);
      font-weight: 400;
      transition: 0.3s;
      cursor: pointer;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }
    .icon {
      color: var(--fontPrimaryColor);
      font-size: 2.2em;
      cursor: pointer;
    }
    button {
      background: var(--fontPrimaryColor);
      border: none;
      color: var(--primaryBackgroundColor);
      padding: 7px 14px;
      font-size: 18px;
      border-radius: 20px;
      font-family: "Poppins", cursive;
      cursor: pointer;
      transition: 0.4s;
      :hover {
        box-shadow: 0 0 14px 2px var(--shadowColor);
      }
    }
    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }
  }
  .cartIcon {
    display: flex;
    position: relative;
    .icon {
      color: var(--fontPrimaryColor);
      font-size: 35px;
      cursor: pointer;
    }
    h4 {
      padding: 2px 5px;
      top: -10px;
      right: -5px;
      border-radius: 10px;
      position: absolute;
      background-color: var(--fontPrimaryColor);
      font-weight: 300;
      color: var(--primaryBackgroundColor);
    }
  }
  .toggleTheme {
    .themeIcon {
      font-size: 1.6em;
      cursor: pointer;
      color: var(--fontPrimaryColor);
    }
  }
  .mobile-menu {
    position: absolute;
    color: var(--fontPrimaryColor);
    right: 5%;
    font-size: 24px;
    cursor: pointer;
    transition: 0.3s;
    display: none;
    margin-top: 7px;
    :hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 770px) {
    .mobileIcons {
      display: flex;
      position: fixed;
      right: 4em;
      top: 10px;
      align-items: center;
      gap: 8px;
      z-index: 9999999999;
      hr {
        height: 24px;
      }
      .cartIcon {
        display: flex;
        position: relative;
        .icon {
          font-size: 40px;
          cursor: pointer;
        }
        h4 {
          padding: 2px 3px;
          top: -10px;
          right: -5px;
          border-radius: 10px;
          position: absolute;
          background-color: var(--fontSecondaryColor);
          font-weight: 300;
        }
      }
      .icon2 {
        font-size: 1.7em;
      }
    }
    .nav-menu {
      background: var(--primaryBackgroundColor);
      width: 90%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 10%;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0%;
      right: -100%;
      transition: 0.3s;
      z-index: 999999;
      border-left: 1px solid var(--fontSecondaryColor);
    }
    .mobile-menu {
      display: block;
      z-index: 9999999;
    }
    .nav-menu.active {
      right: 0%;
    }
  }
  @media (max-width: 500px) {
    .logo {
      width: 50px;
    }
    .nav-menu {
      width: 98%;
    }
    .modal {
      z-index: 99999999999;
      width: 98%;
    }
  }
`;

export default Navbar;
